import React from 'react'

const ConfirmCloseIcon = (props: any) => {
  const { fill } = props;
  return (
    <>
        <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15.5 2.45468L1.5 16.4547M15.5 16.4546L1.5 2.45459" stroke={fill} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    </>
  )
}

export default ConfirmCloseIcon